/// Port of mobile/lib/core/ui/snackbar/ui/snackbar_host.dart.
/// Anchored at the top so toasts stay clear of game chrome.

import type { ReactNode } from 'react';

import { PixelSnackBar } from './PixelSnackBar';
import { useSnackbarStore } from './snackbarStore';

export function SnackbarHost({ children }: { children: ReactNode }) {
  const snack = useSnackbarStore((s) => s.snack);
  const clear = useSnackbarStore((s) => s.clear);

  return (
    <>
      {children}
      {snack && (
        <div className="pointer-events-none fixed inset-x-0 top-0 z-[100] flex justify-center safe-area-top">
          <div
            key={snack.id}
            className="pointer-events-auto"
            style={{ animation: 'dinodash-snack-in 220ms ease-out' }}
          >
            <PixelSnackBar snack={snack} onDismiss={clear} />
          </div>
        </div>
      )}
    </>
  );
}
